import React, { Component } from 'react';
import { Eye, EyeOff, Mail, Lock, LogIn, ShieldCheck } from 'lucide-react';
import host from '../../assets/js/Host';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { toaster } from 'evergreen-ui';

const cookies = new Cookies();

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
      showPassword: false,
      emailFocused: false,
      passwordFocused: false,
    };
  }

  signIN = (e) => {
    e.preventDefault();
    const { email, password } = this.state;

    if (!email || !password) {
      toaster.danger('يرجى إدخال البريد الإلكتروني وكلمة المرور');
      return;
    }

    this.setState({ loading: true });

    axios
      .post(host + `dashbord/login`, { email, password })
      .then((response) => {
        cookies.set('tokenUser', response.data.data.token, { expires: new Date(Date.now() + 604800000) });
        cookies.set('token', response.data.data.token, { expires: new Date(Date.now() + 604800000) });
        localStorage.setItem('role', response.data.data.role);
        localStorage.setItem('name', response.data.data.name);
        const role = response.data.data.role;
        if (role === 3) window.location.href = '/packagingv2';
        else if (role === 4) window.location.href = '/Devices';
        else if ([-5, -6, -7].includes(role)) window.location.href = '/s_home';
        else window.location.href = '/Cate2';
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (error.response) {
          toaster.danger('الرجاء التحقق من البريد الالكتروني وكلمة المرور');
        }
      });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.signIN(e);
    }
  };

  render() {
    const { email, password, loading, showPassword, emailFocused, passwordFocused } = this.state;

    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Alexandria:wght@500;700;800;900&family=IBM+Plex+Sans+Arabic:wght@400;500;600;700&display=swap');

          .lg-page *, .lg-page *::before, .lg-page *::after {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          :root {
            --lg-ink: #0d1b19;
            --lg-petrol: #0c4f49;
            --lg-petrol-deep: #073430;
            --lg-petrol-soft: #eaf3f1;
            --lg-amber: #e5a63c;
            --lg-porcelain: #f4f6f5;
            --lg-line: #dfe7e4;
            --lg-muted: #5f716d;
          }

          .lg-page {
            min-height: 100vh;
            min-height: 100dvh;
            display: flex;
            direction: rtl;
            font-family: 'IBM Plex Sans Arabic', 'Tajawal', sans-serif;
            background: var(--lg-porcelain);
            color: var(--lg-ink);
          }

          /* ---------- لوحة العلامة (يسار الشاشة في RTL) ---------- */

          .lg-brand {
            position: relative;
            flex: 1 1 55%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 56px 64px;
            background: linear-gradient(160deg, var(--lg-petrol-deep) 0%, var(--lg-petrol) 55%, #0a5c54 100%);
            color: #fff;
          }

          /* المزيج المتحرّك — توقيع الصفحة: لونان يمتزجان ببطء خلف الاسم */
          .lg-blend {
            position: absolute;
            border-radius: 50%;
            filter: blur(90px);
            opacity: 0.55;
            will-change: transform;
          }

          .lg-blend--amber {
            width: 46vmax;
            height: 46vmax;
            background: radial-gradient(circle at 35% 35%, #f0b855, #b96f14 70%);
            top: -14vmax;
            left: -10vmax;
            animation: lgBlendA 22s ease-in-out infinite alternate;
          }

          .lg-blend--teal {
            width: 40vmax;
            height: 40vmax;
            background: radial-gradient(circle at 60% 60%, #38b2a3, #0c4f49 75%);
            bottom: -16vmax;
            right: -8vmax;
            animation: lgBlendB 26s ease-in-out infinite alternate;
          }

          @keyframes lgBlendA {
            from { transform: translate(0, 0) scale(1); }
            to   { transform: translate(9vmax, 12vmax) scale(1.18); }
          }

          @keyframes lgBlendB {
            from { transform: translate(0, 0) scale(1.1); }
            to   { transform: translate(-8vmax, -10vmax) scale(0.92); }
          }

          /* نسيج نقاط خفيف يمنح العمق */
          .lg-brand::after {
            content: '';
            position: absolute;
            inset: 0;
            background-image: radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px);
            background-size: 26px 26px;
            pointer-events: none;
          }

          .lg-brand__top {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: center;
            gap: 12px;
            font-weight: 600;
            font-size: 15px;
            letter-spacing: 0.2px;
            color: rgba(255, 255, 255, 0.85);
            animation: lgRise 0.7s 0.1s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          .lg-brand__badge {
            width: 38px;
            height: 38px;
            border-radius: 12px;
            display: grid;
            place-items: center;
            background: rgba(255, 255, 255, 0.12);
            border: 1px solid rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(6px);
          }

          .lg-brand__center {
            position: relative;
            z-index: 1;
          }

          .lg-wordmark {
            font-family: 'Alexandria', 'IBM Plex Sans Arabic', sans-serif;
            font-weight: 900;
            font-size: clamp(64px, 9vw, 128px);
            line-height: 1.05;
            background: linear-gradient(100deg, #ffffff 20%, #ffd98c 45%, #9fe8dd 70%, #ffffff 90%);
            background-size: 250% 100%;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: lgWordmark 9s ease-in-out infinite, lgRise 0.8s 0.25s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          @keyframes lgWordmark {
            0%, 100% { background-position: 0% 0; }
            50%      { background-position: 100% 0; }
          }

          .lg-brand__tagline {
            margin-top: 18px;
            max-width: 34ch;
            font-size: 17px;
            line-height: 1.9;
            color: rgba(255, 255, 255, 0.72);
            animation: lgRise 0.8s 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          .lg-brand__bottom {
            position: relative;
            z-index: 1;
            font-size: 13px;
            color: rgba(255, 255, 255, 0.45);
            animation: lgRise 0.8s 0.55s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          /* ---------- لوحة النموذج ---------- */

          .lg-panel {
            flex: 0 1 620px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 48px 32px;
            background: var(--lg-porcelain);
          }

          .lg-form {
            width: 100%;
            max-width: 400px;
          }

          .lg-form__head {
            margin-bottom: 40px;
            animation: lgRise 0.7s 0.15s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          .lg-form__title {
            font-family: 'Alexandria', 'IBM Plex Sans Arabic', sans-serif;
            font-weight: 800;
            font-size: 30px;
            color: var(--lg-ink);
          }

          .lg-form__subtitle {
            margin-top: 10px;
            font-size: 15px;
            line-height: 1.8;
            color: var(--lg-muted);
          }

          .lg-field {
            margin-bottom: 22px;
            animation: lgRise 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          .lg-field:nth-of-type(1) { animation-delay: 0.28s; }
          .lg-field:nth-of-type(2) { animation-delay: 0.4s; }

          .lg-label {
            display: block;
            margin-bottom: 9px;
            font-size: 13.5px;
            font-weight: 600;
            color: var(--lg-muted);
            transition: color 0.25s ease;
          }

          .lg-label.is-focused {
            color: var(--lg-petrol);
          }

          .lg-input-wrap {
            position: relative;
          }

          .lg-input {
            width: 100%;
            padding: 15px 50px 15px 48px;
            font-family: inherit;
            font-size: 15.5px;
            color: var(--lg-ink);
            background: #ffffff;
            border: 1.5px solid var(--lg-line);
            border-radius: 14px;
            direction: rtl;
            transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
          }

          .lg-input::placeholder {
            color: #a7b5b1;
          }

          .lg-input:hover {
            border-color: #c3d2cd;
          }

          .lg-input:focus {
            outline: none;
            border-color: var(--lg-petrol);
            box-shadow: 0 0 0 4px rgba(12, 79, 73, 0.12), 0 10px 30px -12px rgba(12, 79, 73, 0.25);
          }

          .lg-input__icon {
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #a7b5b1;
            pointer-events: none;
            transition: color 0.25s ease;
            display: flex;
          }

          .lg-input__icon.is-active {
            color: var(--lg-petrol);
          }

          .lg-toggle {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border: none;
            border-radius: 10px;
            background: transparent;
            color: #a7b5b1;
            cursor: pointer;
            transition: color 0.2s ease, background 0.2s ease;
          }

          .lg-toggle:hover {
            color: var(--lg-petrol);
            background: var(--lg-petrol-soft);
          }

          .lg-toggle:focus-visible {
            outline: 2px solid var(--lg-petrol);
            outline-offset: 2px;
          }

          /* زر الدخول */
          .lg-btn {
            position: relative;
            width: 100%;
            margin-top: 10px;
            padding: 17px;
            border: none;
            border-radius: 14px;
            overflow: hidden;
            font-family: inherit;
            font-size: 16.5px;
            font-weight: 700;
            color: #fff;
            cursor: pointer;
            background: linear-gradient(135deg, var(--lg-petrol) 0%, var(--lg-petrol-deep) 100%);
            box-shadow: 0 12px 28px -10px rgba(12, 79, 73, 0.5);
            transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.25s ease;
            animation: lgRise 0.7s 0.52s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          .lg-btn:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 18px 38px -12px rgba(12, 79, 73, 0.6);
          }

          .lg-btn:active:not(:disabled) {
            transform: translateY(0);
          }

          .lg-btn:focus-visible {
            outline: 3px solid var(--lg-amber);
            outline-offset: 2px;
          }

          .lg-btn:disabled {
            opacity: 0.75;
            cursor: not-allowed;
          }

          /* لمعان يعبر الزر عند التحويم */
          .lg-btn__sheen {
            position: absolute;
            top: 0;
            right: -80%;
            width: 60%;
            height: 100%;
            background: linear-gradient(105deg, transparent, rgba(255, 255, 255, 0.22), transparent);
            transform: skewX(20deg);
            transition: right 0.7s ease;
            pointer-events: none;
          }

          .lg-btn:hover:not(:disabled) .lg-btn__sheen {
            right: 120%;
          }

          .lg-btn__content {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
          }

          .lg-spinner {
            width: 20px;
            height: 20px;
            border: 2.5px solid rgba(255, 255, 255, 0.35);
            border-top-color: #fff;
            border-radius: 50%;
            animation: lgSpin 0.8s linear infinite;
          }

          @keyframes lgSpin {
            to { transform: rotate(360deg); }
          }

          .lg-foot {
            margin-top: 36px;
            padding-top: 22px;
            border-top: 1px solid var(--lg-line);
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            font-size: 13.5px;
            color: var(--lg-muted);
            animation: lgRise 0.7s 0.65s cubic-bezier(0.16, 1, 0.3, 1) both;
          }

          .lg-foot__dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: var(--lg-amber);
            animation: lgPulse 2.2s ease-in-out infinite;
          }

          @keyframes lgPulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50%      { transform: scale(0.7); opacity: 0.5; }
          }

          @keyframes lgRise {
            from { opacity: 0; transform: translateY(22px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          /* ---------- ترويسة الموبايل (تظهر بدل اللوحة الجانبية) ---------- */

          .lg-mobile-brand {
            display: none;
          }

          @media (max-width: 900px) {
            .lg-page {
              flex-direction: column;
            }

            .lg-brand {
              display: none;
            }

            .lg-mobile-brand {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 6px;
              padding: 52px 24px 64px;
              overflow: hidden;
              background: linear-gradient(160deg, var(--lg-petrol-deep) 0%, var(--lg-petrol) 70%);
              color: #fff;
              border-radius: 0 0 32px 32px;
            }

            .lg-mobile-brand .lg-blend--amber {
              width: 70vmin;
              height: 70vmin;
              top: -30vmin;
              left: -20vmin;
              filter: blur(60px);
            }

            .lg-mobile-brand .lg-blend--teal {
              width: 60vmin;
              height: 60vmin;
              bottom: -35vmin;
              right: -15vmin;
              filter: blur(60px);
            }

            .lg-mobile-brand .lg-wordmark {
              font-size: 56px;
              position: relative;
              z-index: 1;
            }

            .lg-mobile-brand__tag {
              position: relative;
              z-index: 1;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.7);
              animation: lgRise 0.8s 0.35s cubic-bezier(0.16, 1, 0.3, 1) both;
            }

            .lg-panel {
              flex: 1;
              padding: 36px 22px 44px;
              margin-top: -26px;
            }

            .lg-form {
              background: #fff;
              border: 1px solid var(--lg-line);
              border-radius: 22px;
              padding: 30px 22px;
              box-shadow: 0 24px 60px -30px rgba(13, 27, 25, 0.25);
            }

            .lg-form__head {
              margin-bottom: 28px;
              text-align: center;
            }

            .lg-form__title {
              font-size: 24px;
            }

            .lg-input {
              padding: 14px 48px 14px 46px;
              font-size: 15px;
            }

            .lg-btn {
              padding: 16px;
              font-size: 16px;
            }
          }

          /* احترام تفضيل تقليل الحركة */
          @media (prefers-reduced-motion: reduce) {
            .lg-page *, .lg-page *::before, .lg-page *::after {
              animation-duration: 0.01ms !important;
              animation-iteration-count: 1 !important;
              transition-duration: 0.01ms !important;
            }
          }
        `}</style>

        <div className="lg-page">
          {/* ترويسة الموبايل */}
          <header className="lg-mobile-brand">
            <span className="lg-blend lg-blend--amber"></span>
            <span className="lg-blend lg-blend--teal"></span>
            <h1 className="lg-wordmark">مزيج</h1>
            <p className="lg-mobile-brand__tag">نظام إدارة متكامل</p>
          </header>

          {/* لوحة النموذج */}
          <main className="lg-panel">
            <div className="lg-form">
              <div className="lg-form__head">
                <h2 className="lg-form__title">مرحباً بعودتك</h2>
                <p className="lg-form__subtitle">سجّل دخولك للوصول إلى لوحة التحكم</p>
              </div>

              {/* البريد الإلكتروني */}
              <div className="lg-field">
                <label className={`lg-label ${emailFocused ? 'is-focused' : ''}`} htmlFor="lg-email">
                  البريد الإلكتروني
                </label>
                <div className="lg-input-wrap">
                  <input
                    id="lg-email"
                    type="email"
                    autoComplete="email"
                    className="lg-input"
                    placeholder="أدخل بريدك الإلكتروني"
                    value={email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    onFocus={() => this.setState({ emailFocused: true })}
                    onBlur={() => this.setState({ emailFocused: false })}
                    onKeyPress={this.handleKeyPress}
                  />
                  <span className={`lg-input__icon ${emailFocused || email ? 'is-active' : ''}`}>
                    <Mail size={19} />
                  </span>
                </div>
              </div>

              {/* كلمة المرور */}
              <div className="lg-field">
                <label className={`lg-label ${passwordFocused ? 'is-focused' : ''}`} htmlFor="lg-password">
                  كلمة المرور
                </label>
                <div className="lg-input-wrap">
                  <input
                    id="lg-password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    className="lg-input"
                    placeholder="أدخل كلمة المرور"
                    value={password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                    onFocus={() => this.setState({ passwordFocused: true })}
                    onBlur={() => this.setState({ passwordFocused: false })}
                    onKeyPress={this.handleKeyPress}
                  />
                  <span className={`lg-input__icon ${passwordFocused || password ? 'is-active' : ''}`}>
                    <Lock size={19} />
                  </span>
                  <button
                    type="button"
                    className="lg-toggle"
                    aria-label={showPassword ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'}
                    onClick={() => this.setState({ showPassword: !showPassword })}
                  >
                    {showPassword ? <EyeOff size={19} /> : <Eye size={19} />}
                  </button>
                </div>
              </div>

              {/* زر الدخول */}
              <button className="lg-btn" onClick={this.signIN} disabled={loading}>
                <span className="lg-btn__sheen"></span>
                <span className="lg-btn__content">
                  {loading ? (
                    <>
                      <span className="lg-spinner"></span>
                      جارٍ تسجيل الدخول...
                    </>
                  ) : (
                    <>
                      <LogIn size={19} />
                      تسجيل الدخول
                    </>
                  )}
                </span>
              </button>

              <div className="lg-foot">
                <span className="lg-foot__dot"></span>
                نظام إدارة متكامل — شركة المزيج للتجارة العامة
              </div>
            </div>
          </main>

          {/* لوحة العلامة — سطح المكتب */}
          <aside className="lg-brand">
            <span className="lg-blend lg-blend--amber"></span>
            <span className="lg-blend lg-blend--teal"></span>

            <div className="lg-brand__top">
              <span className="lg-brand__badge">
                <ShieldCheck size={20} />
              </span>
              لوحة التحكم الإدارية
            </div>

            <div className="lg-brand__center">
              <h1 className="lg-wordmark">مزيج</h1>
              <p className="lg-brand__tagline">
                منصة واحدة لإدارة الطلبات والمنتجات والفريق — كل شيء في مكانه، وبسرعة.
              </p>
            </div>

            <div className="lg-brand__bottom">
              © {new Date().getFullYear()} شركة المزيج للتجارة العامة
            </div>
          </aside>
        </div>
      </>
    );
  }
}

export default Login;